import { combineReducers } from 'redux';
import authReducer from './authReducer';
import customerReducer from './customerReducer';
import productReducer from './productReducer';
import invoiceReducer from './invoiceReducer';
import paymentModeReducer from './paymentModeReducer';
import oldMetalReducer from './oldMetalReducer';
import chitReducer from './chitReducer';
import taxReducer from './taxReducer';
import dailyRateReducer from './dailyRateReducer';
import uiReducer from './uiReducer';
import goldsmithReducer from './goldsmithReducer';
import invoiceNumberMasterReducer from './invoiceNumberMasterReducer';
import reportReducer from './reportReducer';
import communicationReducer from './communicationReducer';
import customerOrderReducer from './customerOrderReducer';
import goldsmithPurchaseReducer from './goldsmithPurchaseReducer';
import repairOrderReducer from './repairOrderReducer';
import expenseReducer from './expenseReducer';
import expenseCategoryReducer from './expenseCategoryReducer';
import expenseVendorReducer from './expenseVendorReducer';
import expenseTypeReducer from './expenseTypeReducer';
import { usersReducer, rolesReducer, rolePermissionsReducer, availableModulesReducer } from './userRoleReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  customers: customerReducer,
  products: productReducer,
  invoices: invoiceReducer,
  paymentModes: paymentModeReducer,
  oldMetal: oldMetalReducer,
  chits: chitReducer,
  taxes: taxReducer,
  dailyRates: dailyRateReducer,
  ui: uiReducer,
  goldsmith: goldsmithReducer,
  invoiceNumberMaster: invoiceNumberMasterReducer,
  reports: reportReducer,
  communication: communicationReducer,
  customerOrders: customerOrderReducer,
  goldsmithPurchases: goldsmithPurchaseReducer,
  repairOrders: repairOrderReducer,
  expenses: expenseReducer,
  expenseCategories: expenseCategoryReducer,
  expenseVendors: expenseVendorReducer,
  expenseTypes: expenseTypeReducer,
  users: usersReducer,
  roles: rolesReducer,
  rolePermissions: rolePermissionsReducer,
  availableModules: availableModulesReducer,
});

export default rootReducer;
